import { Box, Card, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import React from 'react';
import { Link } from 'react-router-dom';

export default function DahsboardCard({
  title,
  value,
  defaultValue = 0,
  color = 'linear-gradient(180deg,rgb(178, 102, 201),rgb(91, 32, 94))',
  path,
  height = 150,
  p,
}) {
  return (
    <Card
      sx={{
        flex: 1,
        background: color,
        color: 'white',
        borderRadius: 3,
        p: p || 3,
        width: '100%',
        height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="subtitle1">{title}</Typography>
      <Box
        display={'flex'}
        sx={{
          justifyContent: 'space-between',
        }}
        pr={2}
      >
        <Typography variant="subtitle1">{value || defaultValue}</Typography>
        {path && (
          <Link to={path} style={{ color: 'white' }}>
            <RemoveRedEyeIcon />
          </Link>
        )}
      </Box>
    </Card>
  );
}
